import React, { useEffect, useState } from "react";
import { Article, AttachMoney,  Block, Download, Search, Summarize} from "@mui/icons-material";
import { Box, Button, LinearProgress, MenuItem, Paper, TextField, Typography } from "@mui/material";
import { DataGridPro, useGridApiRef } from "@mui/x-data-grid-pro";
import { useDispatch, useSelector } from "react-redux";
import { selectCustomersSorted } from "../../state/selectors/catalogs.customers";
import { months } from "../../helpers/months";

import { liquidationStatus } from "../../helpers/liquidationStatus";
import LiquidationStatus from "./LiquidationStatus";

import { fetchBillReport, fetchLiquidations, fetchProductionReport, selectLiquidations, sentToBill, setParams } from "../../state/handlers/liquidation";
import { filterLiquidations, selectLiquidationsSelected } from "../../state/selectors/liquidation";
import { fetchCustomers } from "../../state/handlers/catalogs.customer";
import BillingDialog from "./BillingDialog";


const Liquidation = () => {
    
    const dispatch = useDispatch();
    const apiRef = useGridApiRef();

    const [filter,setFilter] = useState('');
    const [billingDialog, setBillingDialog] = useState(false);

    const customers = useSelector(selectCustomersSorted);

    const {list, loading, params} = useSelector(filterLiquidations(filter));
    const selectedLiquidations = useSelector(selectLiquidationsSelected);

    const handleDownloadBill = (bill) => {
        dispatch(fetchBillReport(bill));
    }
    
    const handleDownloadReport = (bill) => {
        dispatch(fetchProductionReport(bill));
    }
    
    const liquidation_columns = [
        {
            field: 'id',
            headerName: 'Id',
            width: 30,
            sortable: false,
            type: 'number'
        },
        {
            field: 'month',
            headerName: 'Mes',
            sortable: false,
            type: 'string',
            valueGetter:(params)=> params.row.month,
        },
        {
            field: 'year',
            headerName: 'Año',
            sortable: false,
            type: 'string',
            valueGetter:(params)=> params.row.year,
        },
        {
            field: 'customer',
            headerName: 'Cliente',
            sortable: false,
            type: 'string',
            renderCell:(params)=> `${params.row.customer.code} ${params.row.customer.name}`,
            flex:1
        },
        {
            field: 'practices',
            headerName: 'Cantidad Practicas',
            sortable: false,
            type: 'string',
            flex:1
        },
        {
            field: 'samples',
            headerName: 'Cantidad de muestras',
            sortable: false,
            type: 'string',
            flex:1
        },
        {
            field: 'ammount',
            headerName: 'Sub total',
            sortable: false,
            type: 'string',
            flex:1
        },
        {
            field: 'discount',
            headerName: 'Descuento',
            sortable: false,
            type: 'string',
            flex:1
        },
        {
            field: 'samples_discount',
            headerName: 'Descuento',
            sortable: false,
            type: 'string',
            flex:1
        },
        {
            field: 'ammount_balance',
            headerName: 'Total',
            sortable: false,
            type: 'money',
            
            flex:1
        },
        {
            field: 'status',
            headerName: 'Estado',
            sortable: false,
            type: 'string',
            renderCell:(params)=> <LiquidationStatus status={params.row.status}/> ,
            flex:1
        },
        {
            field: 'bill',
            headerName: 'Factura',
            sortable: false,
            renderCell: (params) => params.row.status === 'billed' && params.row.bill.document_id > 0 && 
                    <Button  onClick={()=>handleDownloadBill(params.row)} startIcon={<Download style={{color:'#696969'}}/>}><Typography>{params.row.bill?.number}</Typography></Button>,
            
        },
        {
            field: 'download_bill',
            headerName: 'Reporte',
            sortable: false,
            renderCell: (params) => params.row.status === 'billed' && params.row.bill.report_id > 0 &&
                    <Button  onClick={()=>handleDownloadReport(params.row)} startIcon={<Article style={{color:'#696969'}}/>}/>,
        }
    ];

    useEffect(() => {
        !customers?.lenght && dispatch(fetchCustomers());
    }, []);

    const handleChange = (event) => {
        dispatch(setParams({...params, [event.target.id || event.target.name]:event.target.value}));
    }

    const handleSearch = () => {
        dispatch(fetchLiquidations(params));
    }

    const handleSendToBill = () => {
        setBillingDialog(false);
        dispatch(sentToBill(params, selectedLiquidations));
    }

    const handleSelectedRows = () => {
        const rows = apiRef.current.getSelectedRows();
        dispatch(selectLiquidations([...rows.values()]))
    }

    return(        
        <div className="column-container all-height">
            <div className="header row-container align-center" style={{height:'4em'}}>
                <div>
                    <Typography variant="h5" color="text.black">
                        <Box fontWeight={750}>Liquidaciones</Box>
                    </Typography>
                </div>
            </div>
            
            <div style={{minHeight:'0.5em'}}>
                {   
                    loading &&
                    <LinearProgress/>
                }
            </div>

            <div className="body grow column-container margin-top margin-bottom">

                    <Paper elevation={3} className="row-container" style={{padding:'2em',marginTop:'1em',marginBottom:'1em'}}>

                        <div className="column-container flex-1" style={{ marginRight:'1em',paddingRight:'3em'}}>
                            <div className="row-container" style={{marginBottom:'0.5em'}}>
                                <TextField 
                                    key="month"
                                    id="month"
                                    name="month"
                                    label="Mes" 
                                    size="small"
                                    fullWidth
                                    select
                                    value={params?.month || ''}
                                    sx={{marginRight:'0.5em'}}
                                    onChange={handleChange}
                                >
                                    {
                                        months.map( month => 
                                            <MenuItem key={month.value} value={month.value}>
                                                {month.name}
                                            </MenuItem>
                                        )
                                    }            
                                </TextField>

                                <TextField 
                                    id="year"
                                    name="year"
                                    key="year"
                                    label="Año" 
                                    size="small"
                                    fullWidh   
                                    value={params?.year || ''}
                                    onChange={handleChange}              
                                />

                            </div>

                            <TextField 
                                id="customer"
                                name="customer"
                                key="customer"
                                sx={{marginBottom:'0.5em'}} 
                                variant="outlined" 
                                size="small" 
                                label="Cliente"
                                select
                                value={params?.customer || ''}
                                onChange={handleChange}  
                            >
                                <MenuItem key={'all'} value={'all'}>
                                    {'Todos'}
                                </MenuItem>

                                {
                                    customers.map(customer => (
                                        <MenuItem key={customer.id} value={customer.id}>
                                            {customer.name}
                                        </MenuItem>
                                    ))
                                }
                            </TextField>

                            <div className="row-container">

                                <TextField 
                                    id="status"
                                    name="status"
                                    key="status"
                                    sx={{marginRight:'0.5em'}} 
                                    variant="outlined" 
                                    size="small" 
                                    label="Estado"
                                    fullWidth
                                    select
                                    value={params?.status || ''}
                                    onChange={handleChange}
                                >
                                    {
                                        liquidationStatus.map(status => (
                                            <MenuItem key={status.value} value={status.value}>
                                                {status.name}
                                            </MenuItem>
                                        ))
                                    }
                                </TextField>


                                <Button 
                                    variant="contained" 
                                    sx={{height: '2.8em'}}
                                    color="secondary"
                                    onClick={handleSearch}
                                >
                                    <Search/>
                                </Button>

                            </div>
    
                        </div>

                        <div className="column-container flex-1" style={{ marginRight:'1em',paddingRight:'3em'}}>                        
                            <div className="row-container" style={{marginBottom:'0.5em'}}>
                                    <TextField 
                                        id="filter"
                                        name="filter"
                                        key="filter"
                                        variant="outlined" 
                                        label="Filtra por codigo/nombre de Cliente o Factura" 
                                        size={"small"} 
                                        fullWidth
                                        value={filter || ''}
                                        onChange={(event)=>setFilter(event.target.value)}
                                    >
                                    </TextField>
                            </div>
                        </div>

                        <div className="column-container" style={{marginRight:'1em'}}>


                        </div>

                        <div className="column-container">
                            
                            <Button 
                                variant="outlined" 
                                startIcon={<Block/>}
                                sx={{height:'2.8em', marginBottom:'0.5em'}}
                                color="secondary"
                                disabled
                            >
                                Anular
                            </Button>

                            <div className="grow"></div>

                            <Button 
                                variant="contained" 
                                startIcon={<AttachMoney/>}
                                sx={{height:'2.8em', marginBottom:'0.5em'}}
                                color="secondary"
                                onClick={()=>setBillingDialog(true)}
                                disabled={!selectedLiquidations?.length}
                            >
                                Facturar
                            </Button>

                        </div>
                    </Paper>

                    <div className="grow" >
                        <DataGridPro
                            apiRef={apiRef}
                            {...{rows:list,columns:liquidation_columns}}
                            headerHeight={40}
                            rowHeight={40}
                            onSelectionModelChange={handleSelectedRows}
                            disableColumnMenu
                            checkboxSelection
                            disableSelectionOnClick
                            disableColumnSelector
                            disableMultipleColumnsSorting
                            hideFooter
                        />
                    </div>
            </div>

            {
                billingDialog &&
                <BillingDialog open={billingDialog} onAccept={handleSendToBill} onCancel={()=>setBillingDialog(false)} liquidations={selectedLiquidations}/>
            }

        </div>
    )};

export default Liquidation;